import Modal from "../components/payment/modal";
import SuccessMessage from "../components/payment/SuccessMessage/SuccessMessage";
import { useAuth } from "../context/AuthContext";
import { dictionary } from "../utils/dictionary";
import { ButtonFluxi } from "../components/common/Buttons/ButtonFluxi/ButtonFluxi";
import { useNavigate } from "react-router-dom";

const SuccessPage = () => {
  const { language } = useAuth();
  const navigate = useNavigate();

  const screenWidth = window.innerWidth;
  const navigateTo = screenWidth < 768 ? "/settings" : "/plans";

  return (
    <Modal onClose={() => {}} navigationPath={navigateTo}>
      <SuccessMessage message={dictionary["congratulations"][language]} description={dictionary["plan-updated"][language]} />
      <div style={{ display: "flex", justifyContent: "center", gap: 16 }}>
        <ButtonFluxi text={dictionary["next"][language]} onClick={() => {
          navigate(navigateTo);
        }} />
      </div>
    </Modal>
  );
};

export default SuccessPage;
